module.exports = __webpack_public_path__ + "img/tuceng15.56d7598b.png";